// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3ojkM","overflowing":"ReadFullNote_overflowing__nXV_g"};